module.exports = __webpack_public_path__ + "static/media/bar-code-icon.6c20f188.png";